import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field-matcher"
export default class extends Controller {
  static targets = ["field1", "field2"]

  validate(event) {
    this.field1Target.setCustomValidity('')
    this.field2Target.setCustomValidity('')
    if (this.field1Target.value === "" && this.field2Target.value === "") {
      return true
    }

    if (this.field1Target.value !== this.field2Target.value) {
      this.field2Target.setCustomValidity(this.field2Target.dataset.invalidFeedback)
    }

    if (this.field2Target.checkValidity() === false) {
      event.preventDefault()
    }
  }
}
